import {Form, Formik} from 'formik';
import {useTranslation} from 'next-i18next';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import TextLocal from '@/src/textLocal/containers/TextLocal';

import {Button, Input} from '../../../ui';
import css from '../styles/ForgotPasswordForm.module.css';

const getForgotPasswordSchema = (t) =>
  Yup.object().shape({
    email: Yup.string()
      .test('sectionSymbol', t('emailStep.email_is_invalid'), (value) => {
        if (value === undefined) {
          return true;
        }

        return !value?.includes('§');
      })
      .email(t('emailStep.email_is_invalid'))
      .required(t('emailStep.email_is_required')),
  });

interface ForgotPasswordFormProps {
  handleSubmit: (values: {email: string}) => void;
  isLoading: boolean;
}

const ForgotPasswordForm = ({
  handleSubmit,
  isLoading,
}: ForgotPasswordFormProps) => {
  const {t} = useTranslation('common');

  return (
    <Formik
      initialValues={{email: ''}}
      onSubmit={handleSubmit}
      validationSchema={getForgotPasswordSchema(t)}
    >
      <Form>
        <div className={css.form}>
          {/*@ts-ignore*/}
          <Input
            name={'email'}
            placeholder={t('paymentDetails.billing_email')}
            type={Input.TYPES.EMAIL}
          />
          <div className={css.confirmButton}>
            <Button
              isLoading={isLoading}
              color={Button.COLOR.PRIMARY}
              height={Button.HEIGHT.NORMAL}
              type={Button.TYPES.SUBMIT}
            >
              <TextLocal id={'forgot-password.reset-password'} />
            </Button>
          </div>
        </div>
      </Form>
    </Formik>
  );
};

ForgotPasswordForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ForgotPasswordForm;
